import React, { useEffect, useState } from 'react';
import { PolarArea } from './index';
import { NonIdealState } from '@blueprintjs/core';
import { convertToStacks, NO_DATA_MESSAGE, Stacks } from '../chartUtils';
import { DefaultChartColorScales } from 'styles/chartColors';

/**
 * ChartWrapper for the Polar Area Graph.
 *
 * @param getColorScale
 * @param dimensions
 * @param data
 * @param widgetConfiguration
 * @returns {*}
 * @constructor
 */
export function PolarAreaWrapper({ getColorScale, dimensions, data, noDataMessage=NO_DATA_MESSAGE, widgetConfiguration }) {
	const [convertedData, setConvertedData] = useState<null | Stacks>(null);

	useEffect(() => {
		// the data is null or in the wrong shape and we exit
		if (!data || !Array.isArray(data?.entries)) return;

		// empty data is "valid"
		if (data.entries?.length === 0) {
			setConvertedData({ data: [], properties: [], keys: [], rolled: [], extent: [0, 0] });
			return;
		}

		// data comes in as {key, value, children:[{key1, value}, {key2, value}...]}
		// need as {label:value, key1: value, key2: value}
		const converted = convertToStacks(data);

		converted.colorPropertyMap = {};

		if (widgetConfiguration?.colorScale === DefaultChartColorScales.Sequential) {
			getColorScale.domain([0, converted?.keys?.length || 0]);
			converted.keys.forEach((d, index) => {
				converted.colorPropertyMap[d] = index;
			});
		} else {
			getColorScale.domain(converted?.keys);
			converted.keys.forEach((d) => {
				converted.colorPropertyMap[d] = d;
			});
		}

		setConvertedData(converted);
	}, [data, getColorScale, widgetConfiguration]);

	// If the state is not ideal (the data is null or empty) render the nonIdealState message
	return convertedData?.data?.length > 0 ? (
		<PolarArea data={convertedData} dimensions={dimensions} getColor={getColorScale} />
	) : (
		<NonIdealState
			title="No Data Found"
			icon="graph-remove"
			description={noDataMessage}
		/>
	);
}
